<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.userTarget' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.userTarget' | translate}}</h1>
  </div>
</div>


<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-3 margin-top-10">
        </div>
        <div class="col-sm-3 margin-top-10 left-6 cursor-pointer" (click)="gotoNew()" *ngIf="isBrandLevel">
          <span class="margin-right-7 create-new-span">{{'app.createNew' | translate}}</span>
          <i class="fa fa-plus-circle"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-add-user-target-request *ngIf="addNew||viewMode||reviewMode" (closeEvent)="closeAdding($event)" [viewMode]="viewMode"
                             [reviewMode]="reviewMode" [selectedRequestId]="selectedRequestId" [requestType]="requestType"></crm-add-user-target-request>


<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-treeTable [value]="requests" [resizableColumns]="true" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <th ttResizableColumn [ttSortableColumn]="'name'" style="text-align:center" class="table-edit">
                  {{'transactions.createdBy' | translate}}
                  <p-treeTableSortIcon [field]="'name'"></p-treeTableSortIcon>
                </th>
                <th class="table-edit">{{'users.creationDate' | translate}}</th>
                <th class="table-edit">{{'app.status' | translate}}</th>
                <th width="7%" style="text-align:center;" class="table-edit">{{'app.view'|translate}}</th>
                <th width="7%" style="text-align:center;" class="table-edit">{{'app.reveiew'|translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.edit' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.complete' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.delete' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr [ttRow]="rowNode">
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <span>
                    {{rowData.createdByName}}
                  </span>

                </td>
                <td>{{ rowData.creationDate | date :'dd/MM/yyyy' }}</td>
                <td>{{ getStatusName(rowData.status) }}</td>
                <td>
                  <a class="" href="javascript:;" (click)="view(rowData.id)"><i class="fa fa-eye fa-lg font-size-20"></i></a>
                </td>
                <td>
                  <a class="" href="javascript:;" (click)="review(rowData.id)" *ngIf="canReviewRequest(rowData.type)&& rowData.status==2"><i class="fa fa-comments fa-lg font-size-20"></i></a>
                </td>
                <td>
                  <a class="" href="javascript:;" (click)="edit(rowData.id)" *ngIf="canEditRequest(rowData.type,rowData.status)&&rowData.status==1&&rowData.userTargetRequestDetailCount>0"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td>
                  <a class="" href="javascript:;" (click)="complete(rowData.id)" *ngIf="canCompleteRequest(rowData.type)&&rowData.status==1&&rowData.userTargetRequestDetailCount==0"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td><a href="javascript:;" (click)="confirmDeleteItem(rowData.id)" *ngIf="canDeleteFile "><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>
              </tr>
            </ng-template>
          </p-treeTable>



        </div>

      </div>
    </div>
  </div>
</div>



<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="delete()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
